import { useState } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { suitProcess } from '../../../mocks/trajesMedida';

export default function ProcessSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section ref={ref} className="w-full bg-brand-gray-50 py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="text-center max-w-2xl mx-auto" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Proceso
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            De la primera medida
            <span className="italic text-brand-gray-300"> al evento</span>
          </h2>
          <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.8] mt-5">
            Un viaje de creación de 4 a 6 meses donde cada etapa está cuidadosamente planificada
            para que tu traje sea perfecto en el día más importante.
          </p>
        </div>

        {/* Steps Navigation */}
        <div
          className="mt-14 flex flex-wrap justify-center gap-2 md:gap-3"
          style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms',
          } : {
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms',
            willChange: 'opacity, transform',
          }}
        >
          {suitProcess.map((step, index) => (
            <button
              key={step.step}
              onClick={() => setActiveStep(index)}
              className={`relative font-sans text-sm tracking-wider px-5 py-2.5 rounded-full transition-all duration-300 whitespace-nowrap ${
                index === activeStep
                  ? 'bg-brand-black text-white'
                  : 'bg-white text-brand-gray-500 hover:text-brand-black border border-brand-gray-200'
              }`}
            >
              <span className="mr-1.5 text-xs opacity-60">{String(step.step).padStart(2, '0')}</span>
              {step.title}
            </button>
          ))}
        </div>

        {/* Active Step Detail */}
        <div
          className="mt-10 md:mt-14"
          style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms, transform 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms',
          } : {
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'opacity 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms, transform 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms',
            willChange: 'opacity, transform',
          }}
        >
          <div className="bg-white rounded-[28px] p-8 md:p-12 max-w-3xl mx-auto">
            <div className="flex items-baseline gap-4 mb-4">
              <span className="font-serif text-brand-gray-300 text-4xl md:text-5xl font-light">
                {String(suitProcess[activeStep].step).padStart(2, '0')}
              </span>
              <h3 className="font-serif text-brand-black text-xl md:text-2xl font-medium">
                {suitProcess[activeStep].title}
              </h3>
            </div>
            <p className="font-sans text-brand-gray-500 text-[15px] md:text-base leading-[1.8]">
              {suitProcess[activeStep].description}
            </p>

            {/* Progress indicator */}
            <div className="mt-8 flex items-center gap-2">
              {suitProcess.map((_, i) => (
                <div
                  key={i}
                  className={`h-1 rounded-full transition-all duration-500 ${
                    i === activeStep
                      ? 'w-10 bg-brand-black'
                      : i < activeStep
                        ? 'w-5 bg-brand-gray-300'
                        : 'w-5 bg-brand-gray-200'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="mt-10 flex justify-center gap-2">
          {suitProcess.map((step, i) => (
            <button
              key={step.step}
              onClick={() => setActiveStep(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                i === activeStep ? 'bg-brand-black scale-125' : 'bg-brand-gray-200 hover:bg-brand-gray-300'
              }`}
              aria-label={`Paso ${step.step}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}